import { render, staticRenderFns } from "./select-bbch.vue?vue&type=template&id=811dfa7e"
import script from "./select-bbch.vue?vue&type=script&lang=js"
export * from "./select-bbch.vue?vue&type=script&lang=js"
import style0 from "./select-bbch.vue?vue&type=style&index=0&id=811dfa7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports